// Core
import { Text, Flex } from '@chakra-ui/react';

// Components
import { CheckActiveIcon} from 'components/Icons/Icons';

const MembershipFullInclusionsItem = ({ title, description, isDark }) => {
    return (
    	<Flex gap="8px" mb="10px">
    		<CheckActiveIcon fontSize="20px" />
			<Text style={{letterSpacing: '-0.4px'}}><span style={{ 
				color: '#099BFF', 
				fontWeight: '600', 
				fontStyle: 'italic' }}>{title}</span> {description}</Text>
		</Flex>
	);
};

export default MembershipFullInclusionsItem;